import React , { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import API from "./../../utils/API";

export const RasioKeuanganCompany = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const [data, setData] = useState([]);
  const [rawData, setRawData] = React.useState([]);

  // React.useEffect(() => {
  //   // const path = `rasio-keuangan/${user.perusahaan.id}?year=${year}&kuartal=${kuartal}`;
  //   const path = `aspek-keuangan/rasio?year=${year}&perusahaanId=${user.perusahaan.id}`;
  //   dispatch(getDataAction({ path, type: RASIO_KEUANGAN_SINGLE }));
  // }, [year]);
  // const formatterPercent = (cell) => {
  //   cell = isNaN(cell) ? 0.0 : cell;
  //   cell = cell === Infinity ? 0.0 : cell;
  //   cell = cell.toFixed(2);
  //   return (
  //     <div style={{ fontSize: "24px" }} className={cell < 30 ? "text-danger" : cell < 50 ? "text-warning" : "text-success"}>
  //       <strong>{cell}%</strong>
  //     </div>
  //   );
  // };

  const chartFilterDashboard = useSelector(
    (state) => state.chartFilterDashboard
  );
  const loadData = async () => {
      try {
          var url =
            `/indikator-kesehatan/aspek-keuangan?type=${chartFilterDashboard.type}&startMonth=${chartFilterDashboard.startMonth}&endMonth=${chartFilterDashboard.endMonth}&perusahaanId=${user.perusahaan.id}&startYear=${chartFilterDashboard.startYear}&endYear=${chartFilterDashboard.endYear}`;
        url = url.trim();
        const r = await API.get(url);
        const d = r.data;
        setData(d);
        setRawData(d);
  
      } catch (err) {
        console.error(err?.response?.data ?? "");
      }
  };

  React.useEffect(() => {
    loadData();
  }, [
    chartFilterDashboard
  ]); 

  return (
    <div className="card container py-3 border-0 h-100">
      <h3>Rasio Keuangan</h3>
        {data.length === 0 ? (
          <center className="p-4">
            <tr>
                <td colSpan="3" style={{ textAlign: "center", fontStyle: "italic" }}>
                    Data tidak tersedia
                  </td>
              </tr>
          </center>
        ) : (
          data?.map((d, i) => (
          <ul style={{ display: "flex" }}>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                <li>{d.year}</li>
                    <small style={{ color: "#787373" }}>Tahun</small>
                  </center>
                </li>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                        <li>{d.hasilRoe}</li>
                    <small style={{ color: "#787373" }}>Roe</small>
                  </center>
                </li>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                        <li>{d.hasilRoi}</li>
                    <small style={{ color: "#787373" }}>Roi</small>
                  </center>
                </li>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                        <li>{d.hasilBopo}</li>
                    <small style={{ color: "#787373" }}>Bopo</small>
                  </center>
                </li>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                        <li>{d.hasilEbitda}</li>
                    <small style={{ color: "#787373" }}>Ebitda</small>
                  </center>
                </li>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                        <li>{d.hasilCashRatio}</li>
                    <small style={{ color: "#787373" }}>Cash Ratio</small>
                  </center>
                </li>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                        <li>{d.hasilCurrentRatio}</li>
                    <small style={{ color: "#787373" }}>Current Ratio</small>
                  </center>
                </li>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                        <li>{d.hasilPeriodTahunBuku}</li>
                    <small style={{ color: "#787373" }}>Period Tahun Buku</small>
                  </center>
                </li>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                        <li>{d.hasilPeriodPerbaikan}</li>
                    <small style={{ color: "#787373" }}>Period Perbaikan</small>
                  </center>
                </li>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                        <li>{d.hasilTatoTahunBuku}</li>
                    <small style={{ color: "#787373" }}>TATO Tahun Buku</small>
                  </center>
                </li>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                        <li>{d.hasilTatoPerbaikan}</li>
                    <small style={{ color: "#787373" }}>TATO Perbaikan</small>
                  </center>
                </li>
                <li style={{ fontSize: "16px", margin: "1.25em" }}>
                  <center>
                        <li>{d.hasilTmsTA}</li>
                    <small style={{ color: "#787373" }}>TMSTA</small>
                  </center>
                </li>
          </ul>
          ))
        )}
      </div>
  );
};
